import { ApplicationLooper } from "./looper/ApplicationLooper";
import { SwaggerClassBuilder } from "./SwaggerClassBuilder";
import { SwaggerControllerBuilder } from "./SwaggerControllerBuilder";
import { ApplicationSchema } from "./schema/ApplicationSchema";
import { ObjectSchema } from "./schema/type/ObjectSchema";

export class SwaggerApplicationBuilder 
{
    private schema: ApplicationSchema;
    constructor(schema: ApplicationSchema)
    {
        this.schema = schema;
    }
    runSynch(): { controllers: { [name: string]: string[] }, classes: { [name: string]: string[] } }
    {
        let ans: {
            controllers: { [name: string]: string[] }, classes: { [name: string]: string[] }
        } = { controllers: {}, classes: {} };

        for (let i = 0; i < this.schema.controllers.length; i++)
        {
            const controller = this.schema.controllers[i];
            let builder = new SwaggerControllerBuilder(controller);
            let lines = builder.runSynch();
            ans.controllers[`${controller.tag}_${controller.name}`] = lines;
        }
        let builder = new ApplicationLooper(this.schema);
        let classes: ObjectSchema[] = builder.getObjects(true, () => { });
        classes = classes.filter(c => c.name);
        for (let i = 0; i < classes.length; i++)
        {
            const element = classes[i];
            let builder = new SwaggerClassBuilder(element);
            let lines = builder.runSynch();
            ans.classes[element.name] = lines;
        }
        return ans;
    }
}